<template>
  <el-row>
    <table-template :queryParams="queryParams" actionUrl="/businessIntranet/findMyBusinessSpreadOrderList.action"
                    ref="Table">
      <template slot="search">
        <el-row>
          <el-form :inline="true" >
            <el-form-item>
              <el-select v-model="queryParams.status" :clearable="true" :filterable="true" placeholder="推广状态">
                <el-option :value="1" label="推广中"></el-option>
                <el-option :value="2" label="推广完成"></el-option>
                <el-option :value="3" label="推广中止"></el-option>
              </el-select>
            </el-form-item>

              <el-form-item>
              <el-date-picker
                  @change="onDateTimeChange"
                  end-placeholder="创建结束日期"
                  range-separator="至"
                  start-placeholder="创建开始日期"
                  type="datetimerange"
                  v-model="queryParams.startEndTime">
              </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-date-picker
                      @change="onDateTimeChange1"
                      end-placeholder="拨打结束日期"
                      range-separator="至"
                      start-placeholder="拨打开始日期"
                      type="datetimerange"
                      v-model="queryParams.startEndTime1">
              </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-button @click="$refs.Table.search()" type="warning">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button @click="exportExcel()" type="warning">导出</el-button>
            </el-form-item>
          </el-form>
        </el-row>

      </template>
      <template slot="item">

        <el-table-column
            label="订单号"
            width="200px"
        >
          <template slot-scope="scope">
            <p>{{ scope.row.spreadOrderNumber }}</p>

          </template>
        </el-table-column>
        <el-table-column
            label="用户信息"

        >
          <template slot-scope="scope">
            <p>{{scope.row.contacts}}- {{scope.row.phone}}</p>
            <p>维护人：{{scope.row.maintenanceName}}</p>

          </template>
        </el-table-column>

        <el-table-column
                label="订单金额"

        >
          <template slot-scope="scope">
            <p>{{scope.row.spreadTotalMoney/100}}元</p>
            <p>已消耗：{{scope.row.spreadCardUsedMoney/100}}元</p>
          </template>
        </el-table-column>
        <el-table-column
                prop="spreadModuleCount"
                label="推广车源"
                width="100px"
        >
        </el-table-column>

        <el-table-column
            label="推广效果"
            width="150px"
        >
          <template slot-scope="scope">
              <p>浏览量：{{scope.row.browseCount}}</p>
              <p>拨打量：{{scope.row.businessBrowseCount}}</p>
          </template>
        </el-table-column>

        <el-table-column
                label="推广状态"
                width="120px"
        >
          <template slot-scope="scope">
            {{ scope.row.status|spreadStatusFilter }}
          </template>
        </el-table-column>

          <el-table-column
                  label="创建时间"
                  width="180px"
          >
              <template slot-scope="scope">
                  {{ scope.row.spreadStartTime|dateTimeFormat }}
              </template>
          </el-table-column>
          <el-table-column
                  label="完成时间时间"
                  width="180px"
          >
              <template slot-scope="scope">
                  {{ scope.row.spreadEndTime|dateTimeFormat }}
              </template>
          </el-table-column>
        <el-table-column
            label="操作"
            width="200px"
        >
            <template scope="scope">
                <el-button type="text" @click="$router.push({path:'/home/intranetSpreadRecord',query:{id:scope.row.id}})">查看详情</el-button>
              <el-button  type="text"  v-confirm  requestUrl="/businessIntranet/changeSpreadOrderCarStatus.action" :confirm-data="{id:scope.row.id,status:3}" @onConfirm="$refs.Table.search()">推广中止</el-button>
            </template>
        </el-table-column>

      </template>
    </table-template>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'spreadIntranetManagement',
  data: function () {
    return {

      queryParams: {
        status: 1,
        spreadStartTime: null,
        spreadEndTime: null,
        dialStartTime: null,
        dialEndTime: null
      }
    }
  },
  activated: function () {
    this.$refs.Table.search()
  },
  watch: {
    'queryParams.status': function () {
      this.$refs.Table.search()
    }
  },
  methods: {
    onInputConfirm: function () {
      this.$refs.Table.search()
    },
    openUrl: function (shareUrl) {
      this.urlDialogVisible = true
      this.urlVal = shareUrl
    },
    exportExcel: function () {
      let _this = this

      let dataStr = ''

      if (this.queryParams.status) {
        dataStr += '&status=' + this.queryParams.status
      }

      if (this.queryParams.spreadStartTime) {
        dataStr += '&spreadStartTime=' + this.queryParams.spreadStartTime
      }
      if (this.queryParams.spreadEndTime) {
        dataStr += '&spreadEndTime=' + this.queryParams.spreadEndTime
      }

      if (this.queryParams.dialStartTime) {
        dataStr += '&dialStartTime=' + this.queryParams.dialStartTime
      }
      if (this.queryParams.dialEndTime) {
        dataStr += '&dialEndTime=' + this.queryParams.dialEndTime
      }

      let userInfo = _this.getLoginInfo()
      let loginPath = userInfo.loginPath
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }
      window.location.href = Config.baseUrl + 'businessIntranet/findMyBusinessSpreadOrderListExcel.action?' + 'token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath + dataStr
    },
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.spreadStartTime = dates[0].getTime()
        this.queryParams.spreadEndTime = dates[1].getTime()
      } else {
        this.queryParams.spreadStartTime = null
        this.queryParams.spreadEndTime = null
      }
      this.$refs.Table.search()
    },
    onDateTimeChange1 (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.dialStartTime = dates[0].getTime()
        this.queryParams.dialEndTime = dates[1].getTime()
      } else {
        this.queryParams.dialStartTime = null
        this.queryParams.dialEndTime = null
      }
      this.$refs.Table.search()
    }
  },
  filters: {
    spreadStatusFilter: function (val) {
      let str = '非法值'
      switch (val) {
        case 1:
          str = '推广中'
          break
        case 2:
          str = '推广完成'
          break
        case 3:
          str = '推广中止'
          break
      }
      return str
    }
  }
}
</script>

<style scoped>
</style>
